import { render, staticRenderFns } from "./MyOrder.vue?vue&type=template&id=42cc24a1&"
import script from "@/scripts/Mall/MyOrder/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Mall/MyOrder/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports